import { cn } from "@flare/ui";

import type { HeadingProps } from "@/components/v2/Heading/Heading";
import { Heading } from "@/components/v2/Heading/Heading";

export function StepTitle({ children, className, ...restProps }: HeadingProps) {
  return (
    <Heading
      variant="h4"
      className={cn(
        "md:text-8 mx-auto mt-6 max-w-[520px] text-balance text-center font-normal md:mt-[100px] md:leading-10",
        className,
      )}
      {...restProps}
    >
      {children}
    </Heading>
  );
}
